/* bundler (e.g front) will import it
temporary fix because:

import 'x.css' + vite build includes fonts as base64

pending PR to land

import 'x.css' + babel transpiles fails because of ssr (require(.css))
isSsr() ? import('xx') would obviously include fonts as base64...
isSsr() ? require('xx') is not valid esm and fails vite

Possibilities are:
do
- @import 'xx' inside a styled component, because vite does not parse it
- make a single file including all css imports to be imported by front
- css exports in a package.json

Chose solution 2 because 1 is clumsy, we dont want to rely on vite not extracting from imports from stylus
Solution 3 requires bundler understanding.

in Front/client just do import '@lls/viewer/assets/cssImports'
*/

import 'katex/dist/katex.min.css'
import '@yorab/react-paint/react-paint.css'
import '@lls/lls-drawer/lib/assets/lls-drawer.css'
import '@lls/lls-audio/lls-audio.css'
import '@lls/lls-code/lls-code.css'
import '@lls/viewer/viewer.css'

import 'codemirror'
import 'codemirror/mode/xml/xml'
import 'codemirror/mode/python/python'
import 'codemirror/addon/selection/mark-selection'
import 'codemirror/addon/hint/show-hint'
import 'codemirror/addon/hint/xml-hint'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/lint.css'
import 'codemirror/addon/display/rulers'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/theme/material.css'
